import { forwardRef } from 'react';
import MuiTypography, { type TypographyProps as MuiTypographyProps } from '@mui/material/Typography';

export type TypographyProps = MuiTypographyProps;

export const Typography = forwardRef<
  HTMLElement,
  TypographyProps
>(({ variant = 'body1', color = 'text.primary', ...rest }, ref) => (
  <MuiTypography ref={ref} variant={variant} color={color} {...rest} />
));

Typography.displayName = 'Typography';
